/**
 * Sugestões de fuso, compartilhadas por criar e editar viagem. (A moeda é
 * outra história: lista fechada em `TRIP_CURRENCIES`, do @nv/core.)
 *
 * São **sugestões**, não uma trava: qualquer fuso IANA válido é aceito pelo
 * servidor, e a lista existe só para poupar digitação. Nenhum destino, nenhuma
 * data e nenhum valor de viagem específica aparece aqui — a lista é de fusos
 * comuns de quem viaja a partir do Brasil, e nada além disso.
 *
 * Ficam num arquivo só para as duas telas não divergirem: o que se pode
 * escolher ao criar tem de continuar escolhível ao editar.
 */

export const FUSOS = [
  'America/Sao_Paulo',
  'America/Manaus',
  'America/Rio_Branco',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Buenos_Aires',
  'America/Santiago',
  'America/Mexico_City',
  'Europe/Lisbon',
  'Europe/Madrid',
  'Europe/Paris',
  'Europe/Rome',
  'Europe/London',
  'Africa/Johannesburg',
  'Asia/Tokyo',
  'Asia/Dubai',
  'Australia/Sydney',
] as const;

